<!-- session-end.component.html -->
<button (click)="openConfirmation()">End Session</button>

<div *ngIf="showConfirmation">
  <div class="modal">
    <div class="modal-content">
      <p>Do you want to end this session?</p>
      <button (click)="confirm()">Yes</button>
      <button (click)="cancel()">No</button>
    </div>
  </div>
</div>
